import timezoneMap from '../timezone-short-name-map.json' with { type: 'json' };

/**
 *
 * @param timestamp a timestamp
 * @param timeZone a timezone
 * @returns converts a timestamp to a given timezone and then returns a timestamp for the 0 millisecond of that day
 */
export const getZerothMinuteOfDayInTimezone = (timestamp: number, timeZone: keyof typeof timezoneMap): number => {
  const date = new Date(timestamp);

  // get the date in the target timezone
  const localDateStr = date.toLocaleDateString('en-CA', { timeZone: timeZone }); // YYYY-MM-DD format

  // create zeroth minute date
  const midnightLocal = `${localDateStr}T00:00:00`;

  // create a date string UTC, then adjust for timezone offset
  const utc = new Date(midnightLocal + 'Z');

  // get the offset
  const zoned = utc.toLocaleString('sv-SE', { timeZone: timeZone });
  const zonedAsUTC = new Date(zoned + 'Z');
  const offset = utc.getTime() - zonedAsUTC.getTime();

  return utc.getTime() + offset;
};
